"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _TextMixin = require("../../mixins/components/TextMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
/**
 * By default it will create a `<span>` with body type ramp.
 *
 * @related ['Heading', 'Paragraph']
 * @since 6.0.0
 */

var Text = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "Text",
  componentId: "c11n-8-107-0__sc-aiai24-0"
})(["", ""], _TextMixin.TextMixin);
exports.Text = Text;
Text.displayName = 'Text';
Text.propTypes = {
  /**
   * A color token,
   * e.g. `'textDark'`, `'textWhite'`.
   * Set this to an empty string to remove color styles.
   */
  fontColor: _propTypes.default.string,
  /**
   * The font type of the text determines the size, weight, and line-height.
   *
   * Supports inline media query objects
   */
  fontType: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.FONT_TYPES))),
  /**
   * Change the text alignment of the text.
   *
   * Supports inline media query objects.
   */
  textAlign: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the text.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty'])),
  /**
   * The styled-components
   * [polymorphic "as"](https://www.styled-components.com/docs/api#as-polymorphic-prop)
   * prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any
};
Text.defaultProps = {
  fontColor: 'textDark',
  fontType: _constants.FONT_TYPES.body
};

/** @component */